import { lazy } from "react";

export const NewsAsync = lazy(() => import("./News"));
